"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.omitArrayItemConstantDocumentation = exports.omitArrayItem = void 0;
const constants_1 = require("./constants");
/**
 * Symbol is not used as it is not compatible with the step of removing jsonata metadata from the output.
 */
exports.omitArrayItem = "##_MAPPING_omitArrayItem_##";
exports.omitArrayItemConstantDocumentation = [
    {
        label: "$omitArrayItem",
        detail: "$omitArrayItem",
        documentation: `Used to explicitly denote that the array item containing the value should be omitted from the result.
${constants_1.STEDI_BINDING_DISCLAIMER}`,
        insertText: "$omitArrayItem",
    },
];
